import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';

@Entity()
export class OrAspect extends AbstractAspect {
  static override _class = 'OrAspect';

  constructor(doc: PartialEntityData<OrAspect>) {
    super(doc);
  }

  @Field(() => [AbstractAspect])
  aspects: Maybe<AbstractAspect[]>;

  override getMongoFilter(): object | null {
    if (!this.aspects || this.aspects.length === 0) return null;
    return {
      $or: this.aspects.map(aspect => aspect.getMongoFilter()),
    };
  }
}
